import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import EmailEditor from "react-email-editor";

const CampaignEmailComposer = forwardRef(
  ({ content, setContent, template }, ref) => {
    const emailEditorRef = useRef(null);
    const [previewHtml, setPreviewHtml] = useState("");

    const onReady = () => {
      const editor = emailEditorRef.current?.editor;
      if (!editor) return;

      if (content) {
        try {
          const design = JSON.parse(content);
          editor.loadDesign(design);
        } catch (error) {
          console.error("Error parsing content JSON:", error);
          editor.loadBlank({
            body: {
              rows: [
                {
                  cells: [{ content: { values: "" } }],
                },
              ],
            },
          });
        }
      } else {
        editor.loadBlank({
          body: {
            rows: [
              {
                cells: [{ content: { values: "" } }],
              },
            ],
          },
        });
      }

      editor.registerCallback("design:updated", (data) => {
        editor.exportHtml((exportData) => {
          const { design, html } = exportData;
          const designJson = JSON.stringify(design);
          setContent(designJson);
          // console.log("Content updated in setContent:", design);
        });
      });
    };

    const convertToHtml = (callback) => {
      if (!emailEditorRef.current?.editor) {
        callback(previewHtml); // Fallback to last preview
        return;
      }
      emailEditorRef.current.editor.exportHtml((data) => {
        const { html, design } = data;
        const designJson = JSON.stringify(design);
        setPreviewHtml(html); // Update preview
        setContent(designJson); // Update content
        callback(html);
      });
    };

    useImperativeHandle(ref, () => ({
      getEmailHtml: () =>
        new Promise((resolve) => {
          convertToHtml(resolve);
        }),
    }));

    useEffect(() => {
      if (content && content !== previewHtml) {
        setPreviewHtml(content);
      } else if (!content) {
        setPreviewHtml("");
      }
    }, [content, template]);

    useEffect(() => {
      if (emailEditorRef.current?.editor) {
        onReady();
      }
    }, [template]);

    return (
      <div className="w-100 overflow-auto">
        <EmailEditor ref={emailEditorRef} onReady={onReady} />
      </div>
    );
  }
);

export default CampaignEmailComposer;
